<template>
  <div class="sr-duration">
    <template v-if="!getTextModel">
        <div class="sr-duration-hour">
      <el-input
        v-model.number="value.hour"
        type="number"
        size="small"
        :min="0"
      ></el-input>
      <span class="hour">小时</span>
    </div>
    <span class="line">-</span>
    <div class="sr-duration-minute">
      <el-input
        v-model.number="value.minute"
        type="number"
        size="small"
        :min="0"
        :max="59"
      ></el-input>
      <span class="minute">分钟</span>
    </div>
    </template>
    <div v-else>
      {{value.hour?value.hour:'0'}}小时 - {{value.minute?value.minute:'0'}}分钟
    </div>
  </div>
</template>


<script>
export default {
  name: "SrDuration",
  model: {
    prop: "value",
    event: "change",
  },

  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    formComConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 是否采用文字模式
    getTextModel() {
      if (undefined === this.item.isText || '' === this.item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return this.item.isText;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// packages/SrDuration/index.vue